import type { NextPage } from 'next';
import Head from 'next/head';

import { escape } from 'lodash';

import { useServices } from 'hooks/services/useServices';

import { ServicesContainer } from '../routes/services/Services.container';

type ServicesProps = {
  rwgToken?: string;
};

const Services: NextPage<ServicesProps> = (/*{ rwgToken }*/) => {
  const { services } = useServices();

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: services.slice(0, 20).map((service) => ({
      '@type': 'Service',
      name: escape(service.name),
      description: escape(service.description || ''),
      serviceType: escape(service.category_name),
      offers: {
        '@type': 'Offer',
        price: escape(service.price),
        priceCurrency: 'USD',
        eligibleDuration: {
          '@type': 'QuantitativeValue',
          unitCode: 'MIN',
          value: service.total_duration,
        },
      },
    })),
  };

  return (
    <>
      <Head>
        {/* JSON-LD structured data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
      </Head>
      <ServicesContainer />
    </>
  );
};

Services.getInitialProps = function ({ query }) {
  const { rwg_token } = query;
  const rwgToken: string | undefined = Array.isArray(rwg_token)
    ? rwg_token[0]
    : rwg_token;

  return {
    rwgToken,
    metadata: {
      title: 'Services',
    },
  };
};

// Not applicable to Pages
// eslint-disable-next-line import/no-default-export
export default Services;
